import React from 'react';
import './PainelParalaxe2.css';

const PainelParalaxe2 = () => {
  return (
    <div className="paralaxe-container2">
      <div className="paralaxe-conteudo2">
        <div className="paralaxe-texto-container2">
          <h2 className="paralaxe-titulo2">Tradição e Confiança</h2>
          <p className="paralaxe-texto2">
            A confiança de quem sabe que a beleza está nos detalhes, no planejamento consciente e atento e na perfeição técnica da execução.
            Em cada um dos projetos, nos entregamos à paixão de encantar e ver o brilho em seus olhos! 
          </p>
        </div>
      </div>
    </div>
  );
};

export default PainelParalaxe2;